// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_6Z+Y7","radio":"-yziw","label":"duh98"};